<vn-message-panel [scope]="'casinocorelobby'"></vn-message-panel>
